module.exports = __webpack_public_path__ + "static/media/arrow.eef5fde9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Arrow/arrow.svg
 ** module id = 1307
 ** module chunks = 0
 **/